import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { DisplayText } from '../../../display-text/display-text';
const b = bemClassBuilder('v-toggle-input');
/**
 * Renders a single toggle input.
 */
export const ToggleInput = observer(props => {
    const { className, label, name, value: checked, onChange, onChangeValue, style, disabled, id, loading, layout } = props;
    const [isFocused, setIsFocused] = useState(false);
    const handleChange = event => {
        if (disabled)
            return;
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
        onChangeValue === null || onChangeValue === void 0 ? void 0 : onChangeValue(event.target.checked);
    };
    const handleFocus = () => setIsFocused(true);
    const handleBlur = () => setIsFocused(false);
    return (_jsx("div", Object.assign({ className: b.block({ disabled, style, layout }, className), id: id }, { children: _jsxs("label", Object.assign({ className: b.element('label', { disabled }) }, { children: [_jsx("input", { className: b.element('input'), type: "checkbox", name: name, onChange: handleChange, checked: checked, onFocus: handleFocus, onBlur: handleBlur, disabled: disabled }), _jsx("div", { className: b.element('button', { focused: isFocused, checked }) }), _jsx(DisplayText, { className: b.element('label-text'), label: label }), loading && _jsx("span", Object.assign({ className: b.element('loading-dots') }, { children: "." })), props.children] })) })));
});
ToggleInput.displayName = 'ToggleInput';
